module.exports = __webpack_public_path__ + "facilities.jpg";